export function getBucketFileIdsFromContent(jsonNode, result = new Set()) {
  if (jsonNode.type === 'bucketFile') {
    // found a bucket file.
    const fileId = jsonNode.attrs['file-id']
    result.add(fileId)
  }
  if (jsonNode.content && jsonNode.content.length > 0) {
    jsonNode.content.forEach((child) =>
      getBucketFileIdsFromContent(child, result),
    )
  }
  return result
}
